View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
template = require 'app/scripts/views/templates/search_help_popover'

module.exports = class SearchHelpView extends View
  viewTitleKey: 'help'

  render: ->
    @$el.html(template())

    @
